import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './en/translation.json';
import translationTR from './tr/translation.json';

// Çevirileri tanımla
const resources = {
  en: {
    translation: translationEN
  },
  tr: {
    translation: translationTR
  }
};

// Kullanıcının dil tercihini yerel depolamadan al veya tarayıcı dilini kullan veya varsayılan olarak Türkçe'yi belirle
const savedLanguage = localStorage.getItem('i18nextLng');
const browserLanguage = navigator.language.split('-')[0];
const defaultLanguage = savedLanguage || (browserLanguage === 'tr' || browserLanguage === 'en' ? browserLanguage : 'tr');

// i18next yapılandırması
i18n
  .use(initReactI18next) // react-i18next'i i18next'e bağla
  .init({
    resources,
    lng: defaultLanguage, // Varsayılan dil
    fallbackLng: 'tr', // Çeviri bulunamazsa kullanılacak yedek dil
    interpolation: {
      escapeValue: false // React zaten XSS saldırılarına karşı koruma sağlar
    },
    react: {
      useSuspense: false // React Suspense ile uyumluluk
    }
  });

export default i18n; 